<div class="full-width flex flex-row justify-between items-center">
  <div class="title">
    {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.GATEWAY_FORM.HEADER' | translate }}
  </div>
  <button
    *ngIf="codeScannerService.isCodeScannerAvailable$ | async"
    gtm="onOpen"
    gtmAction="Scanner"
    gtmCategory="gatewayCommissioningSerialForm"
    data-at-btn-scan
    mat-raised-button
    color="primary"
    (click)="openScanner()"
  >
    {{ 'GENERAL.BUTTON.SCAN' | translate }}
  </button>
</div>

<div class="flex flex-row lt-md:flex-col gap-[24px] xs:gap-[16px] justify-start items-start">
  <div class="flex flex-col gap-[8px] justify-start items-start flex-[50%] xs:flex[100%]">
    <div
      class="sub-title"
      *ngIf="gatewayCommissioningStore.selectedDevice$ | async as selectedDevice"
    >
      {{
        selectedDevice === deviceType.VITOCONNECT
          ? ('+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.GATEWAY_FORM.VITOCONNECT.SUB_HEADER'
            | translate)
          : ('+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.GATEWAY_FORM.ONE_BASE.SUB_HEADER'
            | translate)
      }}
    </div>
    <div class="mandatory-description">
      <sup>*</sup>
      {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.MANDATORY_FIELDS' | translate }}
    </div>
  </div>
  <div class="flex flex-col justify-start items-start">
    <form class="full-width flex-1" [formGroup]="gatewayFormGroup" data-at-provide-gw-serial>
      <mat-form-field mat-input-height-large-label class="full-width">
        <mat-label>{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.GATEWAY_SERIAL.PLACEHOLDER' | translate
        }}</mat-label>
        <input
          gtm="onTextField"
          gtmId="gateway-serial"
          gtmAction="Gateway serial"
          gtmCategory="gatewayCommissioningSerialForm"
          [gtmOn]="['change', 'focus', 'blur']"
          name="gatewaySerial"
          formControlName="gatewaySerial"
          data-at-gateway-serial-input
          matInput
          required
          [minlength]="minlengthOfSerial"
          [maxlength]="maxlengthOfSerial"
          [pattern]="serialRegExp"
        />
        <mat-spinner
          *ngIf="gatewayCommissioningStore.isGatewayVerificationOngoing$ | async"
        ></mat-spinner>
        <mat-error
          *ngIf="gatewayFormGroup.controls.gatewaySerial?.errors?.required"
          class="pb-[6px]"
          >{{
            '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.GATEWAY_SERIAL.ERROR.REQUIRED' | translate
          }}</mat-error
        >
        <mat-error
          *ngIf="gatewayFormGroup.controls.gatewaySerial?.errors?.pattern"
          class="pb-[6px]"
          >{{
            '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.GATEWAY_SERIAL.ERROR.PATTERN' | translate
          }}</mat-error
        >
        <mat-error
          *ngIf="gatewayFormGroup.controls.gatewaySerial?.errors?.minlength"
          class="pb-[6px]"
          >{{
            '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.GATEWAY_SERIAL.ERROR.MIN' | translate
          }}</mat-error
        >
        <mat-error
          *ngIf="gatewayFormGroup.controls.gatewaySerial?.errors?.maxlength"
          class="pb-[6px]"
          >{{
            '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.GATEWAY_SERIAL.ERROR.MAX' | translate
          }}</mat-error
        >
        <mat-error
          *ngIf="gatewayFormGroup.controls.gatewaySerial?.errors?.isRegistered"
          class="pb-[6px]"
        >
          {{
            '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.GATEWAY_SERIAL.ERROR.REGISTERED'
              | translate
          }}
        </mat-error>
      </mat-form-field>
      <mat-form-field mat-input-height-large-label class="full-width">
        <mat-label>{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.GATEWAY_ID.PLACEHOLDER' | translate
        }}</mat-label>
        <input
          gtm="onTextField"
          gtmId="gateway-password"
          gtmAction="Gateway password"
          gtmCategory="gatewayCommissioningSerialForm"
          [gtmOn]="['change', 'focus', 'blur']"
          name="gatewayPassword"
          formControlName="gatewayPassword"
          data-at-gateway-id-input
          matInput
          required
          [minlength]="minMaxlengthOfGatewayPassword"
          [maxlength]="minMaxlengthOfGatewayPassword"
          [pattern]="gatewayPasswordRegExp"
        />
        <mat-spinner
          *ngIf="gatewayCommissioningStore.isGatewayVerificationOngoing$ | async"
        ></mat-spinner>
        <mat-error *ngIf="gatewayFormGroup.controls.gatewayPassword?.errors?.required">{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.GATEWAY_ID.ERROR.REQUIRED' | translate
        }}</mat-error>
        <mat-error *ngIf="gatewayFormGroup.controls.gatewayPassword?.errors?.minlength">{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.GATEWAY_ID.ERROR.MIN' | translate
        }}</mat-error>
        <mat-error *ngIf="gatewayFormGroup.controls.gatewayPassword?.errors?.maxlength">{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.GATEWAY_ID.ERROR.MAX' | translate
        }}</mat-error>
        <mat-error *ngIf="gatewayFormGroup.controls.gatewayPassword?.errors?.backendError">
          {{
            '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.GATEWAY_SERIAL.ERROR.VERIFICATION_FAILED'
              | translate
          }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
</div>
